import DistrictResource from "./district.resource";

const districtModule = angular
  .module("app.resources.district", [])
  .service("District", DistrictResource);

export default districtModule;



// WEBPACK FOOTER //
// ./src/resources/district/district.module.js